import React, { Component, PropTypes } from 'react';
import VideoRemoteControlButton from 'components/videoRemoteControlButton';
import CompleteLevelButton from 'components/completeLevelButton';
import TeamNames from 'components/teamNames';
import MissionReport from 'components/missionReport';
import Hacked from 'components/hacked';

class PresentNotes extends Component {

  static propTypes = {
    lastSlide: PropTypes.number,
    slides: PropTypes.array.isRequired,
    slide: PropTypes.number.isRequired,
    TOC: PropTypes.array.isRequired,
    prevSlide: PropTypes.func.isRequired,
    nextSlide: PropTypes.func.isRequired,
    getHash: PropTypes.func.isRequired
  }

  componentWillReceiveProps (nextProps) {
    const { slide: oldSlide } = this.props;
    const { slide: newSlide } = nextProps;
    const { notes } = this.refs;
    if (oldSlide !== newSlide) {
      if (notes) {
        notes.scrollTop = 0;
      }
    }
  }

  _renderMainSlide () {
    return <div />;
  }

  _renderNextSlide () {
    const endStyle = {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      margin: 0,
      color: 'white'
    };
    const child = this.props.slide + 1 < this.props.TOC.length ?
      this.props.TOC[this.props.slide + 1].slide :
      null;
    return child ? <div /> : <h1 style={[endStyle]}>END</h1>;
  }

  _renderNotes () {
    const child = this.props.TOC[this.props.slide].slide;
    const { notes, finish, teamNames, missionReportQuestions, hacked } = child.props;
    return (
      <div>
        { !!notes &&
          <div dangerouslySetInnerHTML={{__html: notes}} />
        }
        { !!finish && <CompleteLevelButton /> }
        { !!teamNames && <TeamNames /> }
        { missionReportQuestions &&
          <MissionReport missionReportQuestions={missionReportQuestions} />
        }
        { hacked && <Hacked />}
      </div>
    );
  }

  _renderPreviousSlide () {
    const startStyle = {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      margin: 0,
      color: 'white'
    };
    const child = this.props.slide > 0 ?
      this.props.TOC[this.props.slide - 1].slide :
      null;
    return child ? <div /> : <h1 style={[startStyle]}>START</h1>;
  }

  render () {
    return (
      <div className="present-notes">
        <header className="teacher-remote-header">
          <h2 className="teacher-remote-heading">
            Slide {this.props.slide + 1} of {this.props.TOC.length}
          </h2>
        </header>
        <div className="teacher-remote-buttons">
          <button
              className={
                `btn-arrow ${this.props.slide > 0 && 'ppa-icon-arrow-prev'}`
              }
              onClick={this.props.prevSlide}>
            <span className="text-hide">Prev</span>
          </button>
          <VideoRemoteControlButton />
          <button
              className={
                'btn-arrow ' +
                ((this.props.slide + 1 < this.props.TOC.length)
                 ? 'ppa-icon-arrow-next' : '')
              }
              onClick={this.props.nextSlide}>
            <span className="text-hide">Next</span>
          </button>
        </div>
        <div
            ref="notes"
            className="teacher-remote-notes-wrapper">
          <div className="teacher-remote-notes">
            {this._renderNotes()}
          </div>
        </div>
      </div>
    );
  }
}

export default PresentNotes;



// WEBPACK FOOTER //
// ./src/views/hudTeacherRemote/present/index.jsx